import styled from 'styled-components'

export const FormBuilderWrapper = styled.div`
    width: 100%;
    max-width: 800px;
    min-width: 520px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 24px;
`

export const DragArea = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 20px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
    cursor: grab;

    div[class*='icon'] {
        display: none;
    }

    &:hover {
        div[class*='icon'] {
            display: block;
        }
    }
`
